var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeftOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.207 15.207a1 1 0 01-1.414 0l-4.5-4.5a1 1 0 010-1.414l4.5-4.5a1 1 0 111.414 1.414L8.414 10l3.793 3.793a1 1 0 010 1.414z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4yMDcxIDE1LjIwNzFDMTEuODE2NiAxNS41OTc2IDExLjE4MzQgMTUuNTk3NiAxMC43OTI5IDE1LjIwNzFMNi4yOTI4OSAxMC43MDcxQzUuOTAyMzcgMTAuMzE2NiA1LjkwMjM3IDkuNjgzNDIgNi4yOTI4OSA5LjI5Mjg5TDEwLjc5MjkgNC43OTI4OUMxMS4xODM0IDQuNDAyMzcgMTEuODE2NiA0LjQwMjM3IDEyLjIwNzEgNC43OTI4OUMxMi41OTc2IDUuMTgzNDIgMTIuNTk3NiA1LjgxNjU4IDEyLjIwNzEgNi4yMDcxMUw4LjQxNDIxIDEwTDEyLjIwNzEgMTMuNzkyOUMxMi41OTc2IDE0LjE4MzQgMTIuNTk3NiAxNC44MTY2IDEyLjIwNzEgMTUuMjA3MVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgChevronLeftOutline20 as ReactComponent };